import { createApp } from 'vue'
import LoginIsland from './LoginIsland.vue'
import { LOGIN_ISLAND_ID, GOOGLE_GIS_CLIENT_ID, safeInternalPath } from './login.ts'

const MOUNT_ID = LOGIN_ISLAND_ID

export function mountLoginIsland() {
  const el = document.getElementById(MOUNT_ID)
  if (!el) {
    return
  }
  if (el.dataset.islandMounted === 'true') {
    return
  }
  el.dataset.islandMounted = 'true'
  const redirect = safeInternalPath(el.dataset.redirect)
  const googleClientId = (el.dataset.googleClientId || GOOGLE_GIS_CLIENT_ID).trim()
  el.innerHTML = ''
  createApp(LoginIsland, { redirect, googleClientId }).mount(el)
}

if (typeof document !== 'undefined') {
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', mountLoginIsland)
  } else {
    mountLoginIsland()
  }
}
